import React from 'react';
import { Controller } from 'react-hook-form';
import moment from 'moment';
import { CircularProgress } from '@mui/material';
import useOrdersHistory from './ordershistory-hook';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import { ButtonTypes, CurrentOrdersContentTypes } from '../../../../../../Interfaces/componentTypes';
import AuthInput from '../../../../../../Components/Inputs/AuthInput/authInput';
import Button from '../../../../../../Components/Button/button';
import CompanyOrderItem from '../CurrentOrders/Contents/OrderItem/companyOrderItem';
import AutoComplete from '../../../../../../Components/Inputs/AutoComplete/autoComplete';
import CompanyOrderList from '../CurrentOrders/Contents/OrderList/companyOrderList';
import NoData from '../../../../../../Components/NoData/noData';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import { CloseFilter, Filter } from '../../../../../../Assets/Icons';
import styles from './ordersHistory.module.scss';

export interface IOrdersHistoryProps {
  company_id: number;
  QR: string;
  currencySymbol: string
}

const OrdersHistory: React.FC<IOrdersHistoryProps> = (props) => {
  const { company_id, currencySymbol } = props;
  const {
    errors,
    loading,
    control,
    isFilterBox,
    ordersCount,
    isDialogOpen,
    activeContent,
    filterdOrders,
    selectedOrder,
    orderTypesData,
    dialogComponent,
    hasActiveOrders,
    orderStatusesData,
    onBack,
    onReset,
    register,
    setValue,
    onFilter,
    selectOrder,
    onSearchById,
    onCloseDialog,
    onOpenFilterBox,
    setActiveContent,
    onOpenStatusDialog,
    onOpenPrintInvoceDialog,
  } = useOrdersHistory(props);
  const { t } = useLanguagesHooks();

  return (
    <div className={styles.container}>
      {
        activeContent === CurrentOrdersContentTypes.LIST
        &&
        <div className={styles.filterBox}>
          <div className={styles.filterIconRow}>
            <div className={styles.filterIcon} onClick={onOpenFilterBox}>
              <img src={isFilterBox ? CloseFilter : Filter} alt="filter.svg" />
              <p>{t('My_Business.Current_Orders.Filter')}</p>
            </div>
            {
              ordersCount > 0
              &&
              <div className={styles.ordersCount}>
                <p>{t('My_Business.Current_Orders.Total')}: {ordersCount}</p>
              </div>
            }

          </div>
          <div className={`${styles.filterForm} ${isFilterBox ? styles.open : ''}`}>
            <div className={styles.searchBox}>
              <div className={styles.item}>
                <div className={styles.label}>
                  <p>{t('My_Business.Current_Orders.Search_Label')}</p>
                </div>
                <AuthInput
                  register={register}
                  registerName='order_id'
                  showTextError={false}
                  error={errors.order_id}
                />
              </div>
              <Button
                buttonType={ButtonTypes.Secondary}
                title={t('My_Business.Current_Orders.Search_Button')}
                buttonTitleStyle={styles.buttonTitle}
                onClick={onSearchById}
                buttonStyle={styles.searchButton}
              />
            </div>
            <div className={styles.filterInputs}>
              <div className={styles.datePickerBox}>
                <div className={styles.item}>
                  <div className={styles.label}>
                    <p>{t('My_Business.Current_Orders.Start_Date')}</p>
                  </div>
                  <AuthInput
                    register={register}
                    registerName='start_date'
                    type='date'
                    showTextError={false}
                    style={styles.datePicker}
                    inputBoxStyles={styles.datePickerInput}
                    defaultValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
                <div className={styles.item}>
                  <div className={styles.label}>
                    <p>{t('My_Business.Current_Orders.End_Date')}</p>
                  </div>
                  <AuthInput
                    register={register}
                    registerName='end_date'
                    type='date'
                    showTextError={false}
                    style={styles.datePicker}
                    inputBoxStyles={styles.datePickerInput}
                    placeholder='End'
                    defaultValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
              <div className={styles.autocompleteBox}>
                <Controller
                  control={control}
                  name='order_type'
                  render={({ field: { onChange, name, value } }) => {
                    return (
                      <div className={styles.autoComplete}>
                        <div className={styles.label}>
                          <p>{t('My_Business.Current_Orders.Order_Type')}</p>
                        </div>
                        <AutoComplete
                          value={value}
                          name={name}
                          onChange={(value) => {
                            onChange(value)
                            setValue('order_type', value!)
                          }}
                          data={orderTypesData}
                          labelStyle={styles.inputLabel}
                          showTextError={false}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name='order_status'
                  render={({ field: { onChange, name, value } }) => {
                    return (
                      <div className={styles.autoComplete}>
                        <div className={styles.label}>
                          <p>{t('My_Business.Current_Orders.Order_Status')}</p>
                        </div>
                        <AutoComplete
                          value={value}
                          name={name}
                          onChange={(value) => {
                            onChange(value)
                            setValue('order_status', value!)
                          }}
                          data={orderStatusesData}
                          labelStyle={styles.inputLabel}
                          showTextError={false}
                        />
                      </div>
                    );
                  }}
                />
              </div>
            </div>
            <div className={styles.buttonRow}>
              <Button
                title={t('My_Business.Current_Orders.Reset')}
                buttonType={ButtonTypes.Secondary}
                buttonStyle={styles.resetButton}
                onClick={onReset}
                buttonTitleStyle={styles.resetBtnTitle}
              />
              <Button
                title={t('My_Business.Current_Orders.Filter_Btn')}
                buttonType={ButtonTypes.Primery}
                onClick={onFilter}
              />
            </div>
          </div>
        </div>
      }
      <div className={styles.pageContent}>
        {
          activeContent === CurrentOrdersContentTypes.LIST
          &&
          (hasActiveOrders
            ?
            <CompanyOrderList
              company_id={company_id}
              orders={filterdOrders}
              currencySymbol={currencySymbol}
              selectOrder={selectOrder}
              onOpenStatusDialog={onOpenStatusDialog}
            />
            :
            loading
              ?
              <div className={styles.loadingContainer}>
                <CircularProgress sx={{ color: '#b00020' }} />
              </div>
              :
               <div className={styles.loadingContainer}>
              <NoData
                message={t('No_Data.No_Orders')}
              />
              </div>
              )
        }
        {
          activeContent === CurrentOrdersContentTypes.ITEM
          &&
          <CompanyOrderItem
            order={selectedOrder!}
            currencySymbol={currencySymbol}
            onBack={onBack}
            setContentType={setActiveContent}
            onOpenStatusDialog={onOpenStatusDialog}
            onOpenPrintInvoceDialog={onOpenPrintInvoceDialog}
          />
        }
      </div>
      <CustomDialog
        open={isDialogOpen}
        onClose={onCloseDialog}
        children={dialogComponent}
      />
    </div>
  );
};

export default OrdersHistory;
